import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { orderGroupIdZodSchema } from "@@/shared/order-groups/order-group-id";
import { priceZodSchema } from "@@/shared/prices/price";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { translatableZodSchema } from "@@/shared/translations/translation";
import { z } from "zod";
import { orderEventIdZodSchema } from "../../order-events/events/_order-event-id";
import { orderItemBookableTimeOrderChangeZodSchema } from "../../order-events/events/order-changed-event/order-changes/order-item-bookable-time.order-change";
import { orderIdZodSchema } from "../../order-id";
import { orderItemZodSchema } from "../../order-items/order-item";
import { legacyFeesZodSchema } from "./legacy-fees";
import { receiptProjectionIdZodSchema } from "./receipt-projection-id";

const orderReceiptProjectionZodObject = z.object({
    _id: receiptProjectionIdZodSchema,
    _type: z.literal("ORDER_RECEIPT_PROJECTION"),
    _happenedAt: isoAndUnixZodSchema,
    type: z.enum(["ORIGINAL", "ORDER_CHANGE", "ORDER_REFUND", "ON_PREMISE"]),
    status: z.enum(["PENDING", "SETTLED"]),
    amount: priceZodSchema,
    amountSettled: z.number().int(),
    amountCapturable: z.number().int(),
    amountUnsettled: z.number().int(),
    amountRefunded: z.number().int(),
    amountPendingRefund: z.number().int(),
    paymentEventIds: z.array(orderEventIdZodSchema),
    onPremisePayment: z.boolean(),
    reason: translatableZodSchema.optional(),
    timeChanges: z.array(orderItemBookableTimeOrderChangeZodSchema),
    legacyFees: legacyFeesZodSchema,
    orderItems: z.array(orderItemZodSchema),
    receiptFor: z.object({
        providerId: providerIdZodSchema,
        orderGroupId: orderGroupIdZodSchema,
        orderId: orderIdZodSchema,
        orderEvents: z.array(orderEventIdZodSchema),
    }),
});

type OrderReceiptProjection = z.infer<typeof orderReceiptProjectionZodObject>;

export { orderReceiptProjectionZodObject };
export type { OrderReceiptProjection };
